/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { createContext, use } from 'react';
import type { ActionCandidatesProviderProps, ActionCandidatesProviderValues } from '../interface';

export const ActionCandidatesContext = createContext<ActionCandidatesProviderValues | undefined>(
  undefined,
);

export const ActionCandidatesProvider = (props: ActionCandidatesProviderProps) => {
  const { children, ...rest } = props;
  const { reviewCandidates, buyAgainCandidates } = rest;
  const isReviewCandidates = !!reviewCandidates && !buyAgainCandidates;
  const isBuyAgainCandidates = !!buyAgainCandidates && !reviewCandidates;

  return (
    <ActionCandidatesContext value={{ isReviewCandidates, isBuyAgainCandidates, ...rest }}>
      {children}
    </ActionCandidatesContext>
  );
};

export const useActionCandidates = () => {
  const context = use(ActionCandidatesContext);
  if (!context) {
    throw new Error('useActionCandidates must be used within the ActionCandidatesProvider');
  }
  return context;
};
